// extracted by mini-css-extract-plugin
export default {"root":"ToggleButton_root__0cWAC","toggleWrapper":"ToggleButton_toggleWrapper__rvDdk","activeBtn":"ToggleButton_activeBtn__54RXk"};